<template>
  <div>
    <div
      v-if="isLoading && !isLoaded"
      class="p-5 bg-blue-200 text-blue-800"
      v-text="i18n.loading"
    />
    <div v-else-if="error" class="p-5 bg-red-200 text-red-800" v-text="error" />
    <div v-if="events && events.length">
      <details
        v-for="event in events"
        :key="event.id"
        class="my-2 bg-gray-100"
        :open="event.type == 'log'"
      >
        <summary
          class="text-xs cursor-pointer bg-gray-200 text-gray-600 hover:bg-menu-hover p-2"
          :class="[event.type == 'log' ? 'border-l-4 border-action' : '']"
        >
          <div
            class="inline-flex justify-between"
            style="width: calc(100% - 3em)"
          >
            <span class="uppercase text-black">{{
              event.type.replace("_", " ")
            }}</span>
            <span class="text-gray-900 float-right">{{ event.date }}</span>
          </div>
        </summary>
        <div
          class="pt-2 text-sm p-4 whitespace-pre-line"
          :class="event.type == 'log' ? 'border-l-4 border-action' : ''"
          v-text="event.message"
        />
      </details>
    </div>
    <div v-else-if="isLoaded" class="p-5 text-gray-800" v-text="nolog" />

    <button @click="reload" class="w-full text-sm text-left pl-5 py-2">
      <font-awesome-icon v-if="isLoading" icon="spinner" spin fixed-width />
      <font-awesome-icon v-else icon="redo-alt" fixed-width />
      <span class="pl-3" v-text="i18n.refresh" />
    </button>
  </div>
</template>

<script>
import useSWRV from "@/store/swrv";
import { useStore, computed } from "@/store/composition";

export default {
  props: ["project"],
  setup(props) {
    const store = useStore();

    const nolog = computed(
      () => store.state.dashboard.i18n.project.modals.logs.empty
    );

    const { data, error, isLoading, reload, isLoaded } = useSWRV(
      () => "/api/app/projects/" + props.project.id + "/rendering-events"
    );

    const i18n = computed(() => store.state.app.i18n.components.modal);
    const events = computed(() => data.value && data.value.data);

    return {
      events,

      isLoading,
      isLoaded,
      reload,
      error,

      nolog,
      i18n,
    };
  },
};
</script>
